import { organizationModel } from 'apis/model'
import EmptyHolder from 'components/EmptyHolder'
import _ from 'lodash'
import CustomLazyPaginationWrapper from 'modules/asyncCache/components/CustomLazyPaginationWrapper'
import React, { useContext, useMemo, useState } from 'react'
import renderChannel from 'views/Channel/functions/renderChannel'
import renderChannelAction from 'views/Channel/functions/renderChannelAction'
import { renderShowMore } from 'views/MainPage/functions/renderLimitLoadMore'
import renderPagingLoading from 'views/MainPage/functions/renderPagingLoading'
import ServerContext from 'views/Server/ServerContext'
import { renderOwnChild } from 'views/Shared'
import { getChannelsByProps_Api } from '../../../apis'

const OrganizationChannels = ({
  alwaysVisible = false,
  Wrapper = renderOwnChild,
}) => {
  const [limit, setLimit] = useState(5)

  const { item, handleActionClick } = useContext(ServerContext)

  const edit = _.get(item, 'edit', false)

  const createChannel = useMemo(() => {
    return edit
      ? renderChannelAction(() => handleActionClick('createChannel'), false)
      : null
  }, [edit])

  if (_.isEmpty(item)) {
    return null
  }

  const id = organizationModel.getId(item)

  const type = organizationModel.getType(item)

  return (
    <CustomLazyPaginationWrapper
      id={id}
      key={id}
      auto={false}
      sample={limit}
      query={{
        ':id': id,
        ':type': type,
      }}
      alwaysVisible={true}
      apiInfo={getChannelsByProps_Api}
      renderItem={renderChannel}
      renderLoading={renderPagingLoading}
      renderEmpty={() => <EmptyHolder />}
      renderWrap={(children) => (
        <Wrapper>
          {createChannel}
          {children}
        </Wrapper>
      )}
      renderLoadMoreButton={renderShowMore([limit, setLimit])}
    />
  )
}

export default OrganizationChannels
